<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import Reporter from "../../lib/error.js";

    import { all as getCompanies } from "../../Company.svelte";
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import NewCompanyDialog from "../dialogs/NewCompanyDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import LoadingModal from "../LoadingModal.svelte";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let companies = [];
    export let selected = "";
    //export let value = "";
    export let label = "Choose company";
    export let help = "";
    export let allowCreateNew = true;
    export let allowIndeterminate = true;
    export let style;
    export let variant = "outlined";

    let showNewCompanyDialog = false;
    let loadRequest;
    let errorResult;

    function log(msg) {
        console.log(`[CompanyDropdown]`);
        console.log(msg);
    }

    function handleNew(arg) {
        log(`handleNew() result:`);
        log(arg);

        dispatch("new", arg.detail.addCompany);
        showNewCompanyDialog = false;
    }

    if (!companies.length) {
        log(`loading companies...`);

        loadRequest = getCompanies()
            .then(res => {
                log(`received list of companies`);
                log(res);

                companies = res.data.companies;
            })
            .catch(res => {
                errorResult = Reporter.error(`[CompanyDropdown] there was an error loading companies`, res);
            })
    }

    $: {
        console.log(`Company dropdown selection changed: ${selected}`);
    }

    // TODO: wrap Select and extend with this functionality
    $: {
        log(`companies[] changed in CompanyDropdown`);
        log(companies);

        if (!allowIndeterminate && !selected) {
            log(`selecting first company...`);
            selected = companies[0].name;
        }
    }

</script>

<!-- TODO: for some reason it returns the text value instead of the option avlue -->
<!-- TODO: make "enhanced" property work :( -->
{#if !errorResult}
    {#if companies.length}
        <Select {variant} withLeadingIcon bind:value="{selected}" {label} style="width: 100%; {style}">
            <span slot="icon"><Icon class="material-icons">work</Icon></span>
            {#each companies as company}
                <Option
                    value="{company.id}"
                    selected={selected === company.id}>
                    {company.name}
                </Option>
            {/each}
            {#if allowCreateNew}
                <Option value="-1" on:click={() => showNewCompanyDialog = true}>Create new...</Option>
            {/if}
        </Select>
    {:else}
        loading...
    {/if}
{/if}

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>
        {#if help}
            {help}
        {:else}
            <slot name="help">

            </slot>
        {/if}
    </HelperText>
{/if}

{#await loadRequest}
    <LoadingModal />
{:catch}
    there was an error loading companies
{/await}

{#if allowCreateNew}
    <Overlay show={showNewCompanyDialog} closable={true} on:close={() => {}} background="darken">
        <NewCompanyDialog
                on:new={handleNew}
                show={showNewCompanyDialog}/>
    </Overlay>
{/if}